import React, { useState } from 'react';
import { api } from '../services/api';
import { GSEC_LETTER_ROLES, getStoredUser } from '../utils/gsecLetterAccess';

// Save-as-PDF / Save-as-Word buttons for a deal confirmation document.
// dealType: 'gsec' | 'buyback' | 'repo' - matches the /api/deal-confirmation/:dealType/:id/(pdf|docx) routes.
// Reuses the same role gate as the existing GSEC settlement letter feature.
const DealConfirmationButton = ({
  dealType,
  dealId,
  user: userProp,
  refNumberHint,
  className = 'btn btn-sm btn-outline-secondary',
  style
}) => {
  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState('');
  const user = userProp || getStoredUser();

  if (!user || !GSEC_LETTER_ROLES.includes(user.role) || !dealId) {
    return null;
  }

  const download = async (format) => {
    setDownloading(true);
    setError('');
    try {
      const res = await api.get(`/deal-confirmation/${dealType}/${dealId}/${format}`, { responseType: 'blob' });
      const blob = new Blob([res.data], {
        type: format === 'pdf' ? 'application/pdf' : 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${refNumberHint || dealType + '-confirmation-' + dealId}.${format === 'pdf' ? 'pdf' : 'docx'}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      setError(e.response?.data?.error || e.message || 'Failed to download confirmation');
    } finally {
      setDownloading(false);
    }
  };

  return (
    <span style={{ display: 'inline-flex', gap: 6, alignItems: 'center' }}>
      <button type="button" className={className} style={style} disabled={downloading} onClick={() => download('pdf')} title="Save confirmation as PDF">
        📄 PDF
      </button>
      <button type="button" className={className} style={style} disabled={downloading} onClick={() => download('docx')} title="Save confirmation as Word">
        📝 Word
      </button>
      {error && <span style={{ color: 'red', fontSize: 12 }}>{error}</span>}
    </span>
  );
};

export default DealConfirmationButton;
